import { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { segmentPage } from 'src/helpers/segment';
import findRouteByPath from 'src/helpers/findRouteByPath';

export const SegmentPage = () => {
  const history = useHistory();
  const prevPathname = useRef(history.location.pathname);
  const prevSearchParams = useRef(history.location.search);

  // On URL path changes, inform segment via "PAGE" event
  useEffect(() => {
    segmentPage(prevPathname.current, { genericPath: findRouteByPath(prevPathname.current).path }); //app load
    const unlisten = history.listen((location) => {
      if (
        prevPathname.current !== location.pathname ||
        prevSearchParams.current !== location.search
      ) {
        segmentPage(location.pathname + location.search, {
          genericPath: findRouteByPath(location.pathname).path
        });
        prevPathname.current = location.pathname;
        prevSearchParams.current = location.search;
      }
    });

    return () => unlisten();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default SegmentPage;
